export enum ColumnType {
  String = 'String',
  Date = 'Date',
  Number = 'Number',
}
